module.exports = __webpack_public_path__ + "img/LOGO@2x.7f30d93b.png";